export const about = [
  <>
    A <b>bőr</b> stimulációjának szükséglete már a magzati időszakunktól a végső
    búcsúzásig jelen van. Az <b>érintés</b> közvetít, hatással van a lelki és a
    fizikai állapotunkra, kiemelkedő szerepe van az <b>öngyógyítási</b> funkciók
    során. Ezt a <b>hatást</b> szeretném alkalmazni kezeléseim során.
  </>,
];
export const before = [
  <>
    Előtte 4 nappal ne legyen manuál terápia (masszázs, köpölyözés,
    fizikoterápia, trigger pont kezelés)
  </>,
  <>Előtte 2 nappal a bőrön való krémek, olajok mellőzését kérem</>,
  <>
    Fél óránként 1-2 korty víz fogyasztását javaslom - egyébként is a
    mindennapokban
  </>,
  <>Könnyen levehető ruházat ajánlott</>,
];
export const during = [
  <>
    <b>Bőrön</b> dolgozom - alsóneműben, fehérneműben zajlik a kezelés - a
    kezelendő testrészen kívül a többi rész be van takarva
  </>,
  <>
    Érdemes figyelni a testi reakciókat -{" "}
    <b>a kezelés alatt nem beszélgetünk</b>
  </>,
  <>
    Elhelyezés <b>masszázs ágyon</b> hason, háton és/vagy széken ülve -
    állapottól és kezeléstől függően
  </>,
];
export const after = [
  <>15 napig a manuál kezelés mellőzése</>,
  <>
    5 napig kerülni: szauna, forró fürdő, infralámpa, Bemer kezelés, erős
    fizikai munka, megerőltető sport, hatóanyagos krémek
  </>,
  <>30 percnél további ülés kerülése</>,
  <>Fél óránként 1-2 korty víz</>,
  <>C és D vitamin fogyasztása</>,
  <>
    Egyéni reakciók előfordulhatnak: izomláz, tünetek felerősödése, fáradtság
    vagy nagy energia
  </>,
];
export const usefulFor = [
  [
    <>Stresszoldás, relaxáció</>,
    <>Rehabilitáció, prevenció</>,
    <>Állkapocs környéki duzzanat, fogfájás, fogzás</>,
    <>Általános gyengeség, gyulladások, láz</>,
    <>Fejfájás/migrén</>,
    <>Asthma, allergia, szénanátha</>,
    <>Székrekedés, hasmenés</>,
    <>Bélpanaszok: haspuffadás, reflux</>,
  ],
  [
    <>Vizelettartási gondok, ágybavizelés</>,
    <>Ödémák, érrendszeri/nyirokrendszeri keringési elégtelenségek</>,
    <>
      Váll-, nyak-, hát-, könyök-, csukló-, gerinc-, derék-, csípő-, térd-, boka
      panaszok
    </>,
    <>Rossz tartás, ülő munka miatti diszkomfort érzet</>,
    <>Scoliosis</>,
    <>Golfkönyök, teniszkönyök</>,
    <>Sclerosis multiplex, parkinson kór, stroke</>,
  ],
  [
    <>Szédülés</>,
    <>Nőgyógyászati és menstruációs problémák, klimax</>,
    <>
      Baba projekt, meddőség:
      <ul style={{ listStyleType: "none" }}>
        <li>1. lépés: Menstruáció beállítása</li>
        <li>2. lépés: Termékenységet segítő kezelés</li>
      </ul>
    </>,
    <>Prostata gondok</>,
    <>
      Baba bowen:
      <ul>
        <li>Mozgásfejlődési zavar csecsemő- és gyermekkorban</li>
        <li>Hasfájás</li>
        <li>Rossz alvás</li>
      </ul>
    </>,
  ],
];

export const technique = (
  <>
    A <b>Bowen technika</b> egy neuromuszkuláris/neurofasciális reflex módszer,
    amely előmozdítja az ellazulást, mozgósítja az éppen szükséges testi
    folyamatokat, így vitalizál. Nem terápia.
  </>
);
